export default __webpack_public_path__ + "static/media/succession_planning_copy.d2091063.svg";